import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function allowCookiesReducer(state = initialState.allowCookies, action) {
    switch (action.type) {
        case types.COOKIES_ALLOW:
            return true;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/allowCookiesReducer.js